module.exports = __webpack_public_path__ + "img/august-promotions.cae8d604.png";